import React from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";

const ImportantLinks = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { data: screenReaderData = {}, isLoading: screenReaderAccessLoading } =
    useGetHtmlApiQuery({ url: 28753, lang: languageType });

  if (screenReaderAccessLoading) {
    return <Loader />;
  }

  const pageBody = screenReaderData?.body?.[0]?.processed || "";

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Important Links", "महत्वपूर्ण लिंक")}
        titleLink="/screen-reader"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Important Links", "महत्वपूर्ण लिंक")}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <div className="row">
              <div className="container">
                <div className="important-links">
                  <div dangerouslySetInnerHTML={{ __html: pageBody }}></div>
                  {/* <ul class="inn_list list_cstar">
                    <li>
                      <a href="https://www.india.gov.in/" target="_blank">
                        Link To The National Portal
                      </a>
                    </li>
                    <li>
                      <a href="http://www.powermin.nic.in/" target="_blank">
                        Link To Ministry Of Power Website
                      </a>
                    </li>
                    <li>
                      <a href="https://rti.gov.in/" target="_blank">
                        Link To Right To Information Act Service Portal
                      </a>
                    </li>
                    <li>
                      <a href="http://www.cercind.gov.in/" target="_blank">
                        Link To Central Electricity Regulatory Commission
                      </a>
                    </li>
                    <li>
                      <a href="http://www.cea.nic.in/" target="_blank">
                        Link To Central Electricity Authority
                      </a>
                    </li>
                    <li>
                      <a href="http://www.egazette.nic.in/" target="_blank">
                        Link To e-Gazette website of Directorate of Printing
                      </a>
                    </li>
                    <li>
                      <a href="http://msme.gov.in/" target="_blank">
                        Link To website of Ministry of Micro, Small and Medium
                        Enterprises
                      </a>
                    </li>
                    <li>
                      <a href="http://www.nvsp.in/" target="_blank">
                        Link To National Voter's Service Portal (NVSP)
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://webcast.gov.in/powercoalnre/"
                        target="_blank"
                      >
                        Link to Webcast of Honble Minister Of State(I/C) for
                        Power, Coal and MNRE on "Swachh Bharat Diwas"
                      </a>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportantLinks;
